<div class="compartilhamento-container">
    @if (isEditing) {
        <app-card-content [headerColor]="false" icon="pi pi-user-plus" title="Novo Compartilhamento">
            <form [formGroup]="form" class="grid grid-cols-1 md:grid-cols-12 gap-4">
                <div class="md:col-span-8">
                    <label class="font-semibold block mb-2">Nome</label>
                    <input pInputText class="w-full" formControlName="nome" placeholder="Selecione o médico" />
                    @if (campoInvalido('idSolicitante')) {
                        <small class="erro-campo">Selecione o médico.</small>
                    }
                </div>
                <div class="md:col-span-4 flex items-end md:justify-end">
                    <p-button label="Médico" icon="pi pi-user" (onClick)="abrirPesquisa()"></p-button>
                </div>
                <div class="md:col-span-2">
                    <label class="font-semibold block mb-2">UF</label>
                    <input pInputText class="w-full" formControlName="uf" placeholder="UF" [readonly]="true" />
                </div>
                <div class="md:col-span-4">
                    <label class="font-semibold block mb-2">Data de Entrada</label>
                    <p-datepicker [appendTo]="'body'" formControlName="dtEntrada" dateFormat="dd/mm/yy" inputId="dtEntrada" [showIcon]="true"></p-datepicker>
                    @if (campoInvalido('dtEntrada')) {
                        <small class="erro-campo">{{ mensagemErroCampo('dtEntrada') }}</small>
                    }
                </div>
                <div class="md:col-span-4">
                    <label class="font-semibold block mb-2">Data de Saída</label>
                    <p-datepicker [appendTo]="'body'" formControlName="dtSaida" dateFormat="dd/mm/yy" inputId="dtSaida" [showIcon]="true"></p-datepicker>
                </div>
                <div class="md:col-span-2 flex items-end justify-end gap-2">
                    <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-text" (onClick)="cancelar()"></p-button>
                    <p-button label="Salvar" icon="pi pi-check" (onClick)="salvar()"></p-button>
                </div>
            </form>
        </app-card-content>
    }

    <app-pesquisa [(showDialog)]="showPesquisa" (pessoa)="onPessoaSelecionada($event)"></app-pesquisa>

    <div class="section-wrapper">
        @if (loading()) {
            <div class="mt-2">Carregando compartilhamentos...</div>
        }
        @if (!loading() && erro()) {
            <div class="mt-2 text-red-500">{{ erro() }}</div>
        }

        <app-custom-table [data]="rows()" [metadata]="tableMetadata" [loading]="loading()"></app-custom-table>
    </div>
</div>
